import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import {
  CContactForm,
  CContactFormBlock,
  CContactFormFragments,
  CSeomatic,
  SeomaticData,
} from 'ui'
import { GetServerSidePropsContext } from 'next'
import { CraftGlobals } from 'tsconfig/craft-types'
import { gql } from '@urql/core'
import { getSiteInfo, serverSideValidateWww } from 'shared'
import fragments from '../helpers/gql-fragments'
import { defaultClient } from '../graphql/clients'
import { getI18nResolvedUrl } from '../helpers/locale-tools'
import DefaultLayout from '../layouts/default'
import getGlobals from '../graphql/get-globals'
import { setCacheHeaders } from '../helpers/cache-config'

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const isWww = serverSideValidateWww({ context })

  if (isWww) {
    return {
      notFound: true,
    }
  }

  const siteInfo = getSiteInfo(context.locale ?? '')

  const global = await getGlobals(siteInfo.handle)

  const { data, error } = await defaultClient(siteInfo.handle).query(
    gql`
      query($uri: [String]!, $site: [String]!) {
        entry(uri: $uri, site: $site) {
          ${fragments.seomatic}
          uri
          sectionHandle
          typeHandle
          title
          ... on generalPages_contact_Entry {
            contactForm {
              ...contactForm
            }
          }
        }
      }
      ${CContactFormFragments.field}
    `,
    {
      uri: getI18nResolvedUrl(context.req.url ?? ''),
      site: siteInfo.handle,
    }
  )

  if (error) {
    console.error('GraphQL Errors:', error)
  }

  if (!data.entry) {
    return {
      notFound: true,
    }
  }

  setCacheHeaders(context.res)

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? '', ['common'])),
      entry: data.entry,
      global,
    },
  }
}

type Props = {
  entry: {
    seomatic: SeomaticData
    contactForm: Array<CContactFormBlock>
  }
  global: CraftGlobals
}

export default function Contact({ entry, global }: Props) {
  return (
    <DefaultLayout global={global}>
      <CSeomatic data={entry.seomatic} />
      <CContactForm field={entry.contactForm} />
    </DefaultLayout>
  )
}
